import { TranslocoService } from '@ngneat/transloco';
import { Component, OnInit } from '@angular/core';

interface ILanguage {
   key: string;
   label: string;
}

@Component({
  selector: 'app-lang-selector',
  templateUrl: './lang-selector.component.html',
  styleUrls: ['./lang-selector.component.scss']
})
export class LangSelectorComponent implements OnInit {

  public languages: Array<ILanguage> = [
    {
      key: 'de',
      label: 'DE'
    },
    {
      key: 'en',
      label: 'EN'
    },
  ];
  public selectedLanguage: ILanguage = null;

  constructor(
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    this.setLanguage(this.transloco.getActiveLang());
  }

  public onChangeLanguage(language: any): void {
    this.setLanguage(language.value?.key);
  }

  private setLanguage(key: string): void {
    this.selectedLanguage = this.languages.find((language: ILanguage) => {
      return language.key === key;
    });
    this.transloco.setActiveLang(key);
  }

}
